import { type Olympus } from '@owner/olympus-client'

export interface SettingsTranslations {
  listings: {
    fields: Record<Olympus.Listings.ListingDataIssue['field'], string>
    issueTypes: Record<Olympus.Listings.ListingDataIssue['type'], string>
  }
  titles: Record<string, string>
}

export const settingsEn: SettingsTranslations = {
  listings: {
    fields: {
      address: 'Address',
      cuisine: 'Cuisine',
      isDeliveryEnabled: 'Delivery',
      isPickupEnabled: 'Pickup',
      name: 'Name',
      phone: 'Phone',
      url: 'Domain',
    },
    issueTypes: {
      mismatch: 'mismatched',
      missing: 'missing',
    },
  },
  titles: {
    funnel: 'Funnel Settings',
    general: 'General Settings',
  },
}
